function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var RETRIEVE_RATE_SHEET = {
  BEGIN: 'RETRIEVE_RATE_SHEET_BEGIN',
  SUCCESS: 'RETRIEVE_RATE_SHEET_SUCCESS',
  FAILURE: 'RETRIEVE_RATE_SHEET_FAILURE'
};
var RETRIEVE_RATE_SHEET_EVENTS = [RETRIEVE_RATE_SHEET.BEGIN, RETRIEVE_RATE_SHEET.SUCCESS, RETRIEVE_RATE_SHEET.FAILURE];
export var retrieveRateSheetPromise = function retrieveRateSheetPromise(dispatch, subscriberId, itemTypes) {
  return ThunkHelper(dispatch, RETRIEVE_RATE_SHEET_EVENTS, {
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    method: 'post',
    data: {
      RateSheetItemTypes: itemTypes
    },
    url: 'SubscriberManagement/RetrieveSubscriberRateSheet'
  });
};
export var retrieveRateSheet = function retrieveRateSheet(subscriberId, itemTypes) {
  return function (dispatch) {
    return retrieveRateSheetPromise(dispatch, subscriberId, itemTypes);
  };
};
export var SET_UPDATED_RATE_SHEET_ITEM = 'SET_UPDATED_RATE_SHEET_ITEM';
export var updateRateSheetData = function updateRateSheetData(payload) {
  return {
    type: SET_UPDATED_RATE_SHEET_ITEM,
    payload: payload
  };
};
export var SET_NEW_SHEET_ITEM = 'SET_NEW_SHEET_ITEM';
export var addNewRateSheetData = function addNewRateSheetData(payload) {
  return {
    type: SET_NEW_SHEET_ITEM,
    payload: payload
  };
};
export var SET_NEW_USAGE_SHEET_ITEM = 'SET_NEW_USAGE_SHEET_ITEM';
export var addNewUsageSheetData = function addNewUsageSheetData(payload) {
  return {
    type: SET_NEW_USAGE_SHEET_ITEM,
    payload: payload
  };
};
export var SEARCH_RATE_SHEET = 'SEARCH_RATE_SHEET';
export var searchRateSheet = function searchRateSheet(payload) {
  return {
    type: SEARCH_RATE_SHEET,
    payload: payload
  };
};
export var ADD_RATE_SHEET_ITEM = 'ADD_RATE_SHEET_ITEM';
export var addRateSheetItem = function addRateSheetItem(payload) {
  return {
    type: ADD_RATE_SHEET_ITEM,
    payload: payload
  };
};
export var UPDATE_NEW_BRI_ITEMS = 'UPDATE_NEW_BRI_ITEMS';
export var updateNewBriItems = function updateNewBriItems(payload) {
  return {
    type: UPDATE_NEW_BRI_ITEMS,
    payload: payload
  };
};
export var RESET_BRI_DATA = 'RESET_BRI_DATA';
export var resetBriData = function resetBriData(payload) {
  return {
    type: RESET_BRI_DATA
  };
};
export var UPDATE_SUBSCRIBER_RATE_SHEET = {
  BEGIN: 'UPDATE_SUBSCRIBER_RATE_SHEET_BEGIN',
  SUCCESS: 'UPDATE_SUBSCRIBER_RATE_SHEET_SUCCESS',
  FAILURE: 'UPDATE_SUBSCRIBER_RATE_SHEET_FAILURE'
};
var UPDATE_SUBSCRIBER_RATE_SHEET_EVENTS = [UPDATE_SUBSCRIBER_RATE_SHEET.BEGIN, UPDATE_SUBSCRIBER_RATE_SHEET.SUCCESS, UPDATE_SUBSCRIBER_RATE_SHEET.FAILURE];
export var updatedSubscriberRateSheetDataPromise = function updatedSubscriberRateSheetDataPromise(dispatch, subscriberId, addItems, updateItems) {
  return ThunkHelper(dispatch, UPDATE_SUBSCRIBER_RATE_SHEET_EVENTS, {
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    method: 'post',
    data: {
      AddItems: addItems || [],
      UpdateItems: updateItems || []
    },
    url: 'SubscriberManagement/UpdateSubscriberRateSheet'
  });
};
export var updatedSubscriberRateSheetData = function updatedSubscriberRateSheetData(subscriberId, addItems, updateItems) {
  return function (dispatch) {
    return updatedSubscriberRateSheetDataPromise(dispatch, subscriberId, addItems, updateItems);
  };
};
export var UPDATE_FEE = {
  BEGIN: 'UPDATE_FEE_BEGIN',
  SUCCESS: 'UPDATE_FEE_SUCCESS',
  FAILURE: 'UPDATE_FEE_FAILURE'
};
var UPDATE_FEE_EVENTS = [UPDATE_FEE.BEGIN, UPDATE_FEE.SUCCESS, UPDATE_FEE.FAILURE];
export var updateFeePromise = function updateFeePromise(dispatch, subscriberId, feeDetails) {
  return ThunkHelper(dispatch, UPDATE_FEE_EVENTS, {
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    method: 'post',
    data: feeDetails.Id ? {
      UpdateFees: [feeDetails]
    } : {
      AddFees: [feeDetails]
    },
    url: 'SubscriberManagement/UpdateSubscriberFees'
  });
};
export var updateFee = function updateFee(subscriberId, feeDetails) {
  return function (dispatch) {
    return updateFeePromise(dispatch, subscriberId, feeDetails);
  };
};
export var UPDATE_GLOBAL_FEE_STATUS = {
  BEGIN: 'UPDATE_GLOBAL_FEE_STATUS_BEGIN',
  SUCCESS: 'UPDATE_GLOBAL_FEE_STATUS_SUCCESS',
  FAILURE: 'UPDATE_GLOBAL_FEE_STATUS_FAILURE'
};
var UPDATE_GLOBAL_FEE_STATUS_EVENTS = [UPDATE_GLOBAL_FEE_STATUS.BEGIN, UPDATE_GLOBAL_FEE_STATUS.SUCCESS, UPDATE_GLOBAL_FEE_STATUS.FAILURE];
export var updateGlobalFeeStatusPromise = function updateGlobalFeeStatusPromise(dispatch, subscriberId, feeDetails) {
  return ThunkHelper(dispatch, UPDATE_FEE_EVENTS, {
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    method: 'post',
    data: {
      SuppressFees: [feeDetails]
    },
    url: 'SubscriberManagement/SuppressGlobalSubscriberFees'
  });
};
export var updateGlobalFeeStatus = function updateGlobalFeeStatus(subscriberId, feeDetails) {
  return function (dispatch) {
    return updateGlobalFeeStatusPromise(dispatch, subscriberId, feeDetails);
  };
};
export var RETRIEVE_TAX_CODES = {
  BEGIN: 'RETRIEVE_TAX_CODES_BEGIN',
  SUCCESS: 'RETRIEVE_TAX_CODES_SUCCESS',
  FAILURE: 'RETRIEVE_TAX_CODES_FAILURE'
};
var RETRIEVE_TAX_CODES_EVENTS = [RETRIEVE_TAX_CODES.BEGIN, RETRIEVE_TAX_CODES.SUCCESS, RETRIEVE_TAX_CODES.FAILURE];
export var retrieveTaxCodesPromise = function retrieveTaxCodesPromise(dispatch) {
  return ThunkHelper(dispatch, RETRIEVE_TAX_CODES_EVENTS, {
    method: 'post',
    data: {},
    url: 'SubscriberManagement/RetrieveTaxAssociations'
  });
};
export var retrieveTaxCodes = function retrieveTaxCodes() {
  return function (dispatch) {
    return retrieveTaxCodesPromise(dispatch);
  };
};
export var RETRIEVE_GUIDANCE_ENTITIES = {
  BEGIN: 'RETRIEVE_GUIDANCE_ENTITIES_BEGIN',
  SUCCESS: 'RETRIEVE_GUIDANCE_ENTITIES_SUCCESS',
  FAILURE: 'RETRIEVE_GUIDANCE_ENTITIES_FAILURE'
};
var RETRIEVE_GUIDANCE_ENTITIES_EVENTS = [RETRIEVE_GUIDANCE_ENTITIES.BEGIN, RETRIEVE_GUIDANCE_ENTITIES.SUCCESS, RETRIEVE_GUIDANCE_ENTITIES.FAILURE];
export var retrieveGlGuidanceEntitiesPromise = function retrieveGlGuidanceEntitiesPromise(dispatch, currency) {
  return ThunkHelper(dispatch, RETRIEVE_GUIDANCE_ENTITIES_EVENTS, {
    method: 'post',
    data: {
      Currency: currency
    },
    url: 'SubscriberManagement/RetrieveGLGuidanceEntities'
  });
};
export var retrieveGuidanceEntities = function retrieveGuidanceEntities(currency) {
  return function (dispatch) {
    return retrieveGlGuidanceEntitiesPromise(dispatch, currency);
  };
};
export var SEARCH_FEES = {
  BEGIN: 'SEARCH_FEES_BEGIN',
  SUCCESS: 'SEARCH_FEES_SUCCESS',
  FAILURE: 'SEARCH_FEES_FAILURE'
};
var SEARCH_FEES_EVENTS = [SEARCH_FEES.BEGIN, SEARCH_FEES.SUCCESS, SEARCH_FEES.FAILURE];
export var searchSubscriberFeesPromise = function searchSubscriberFeesPromise(dispatch, subscriberId, searchParams) {
  return ThunkHelper(dispatch, SEARCH_FEES_EVENTS, {
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    method: 'post',
    data: searchParams,
    url: 'SubscriberManagement/SearchSubscriberFees'
  });
};
export var searchSubscriberFees = function searchSubscriberFees(subscriberId, searchParams) {
  return function (dispatch) {
    return searchSubscriberFeesPromise(dispatch, subscriberId, searchParams);
  };
};
export var SET_SELECTED_FEE_ID = 'SET_SELECTED_FEE_ID';
export var setSelectedFeeId = function setSelectedFeeId(payload) {
  return {
    type: SET_SELECTED_FEE_ID,
    payload: payload
  };
};
export var SET_PRICING_PLAN_ID = 'SET_PRICING_PLAN_ID';
export var setPricingPlanId = function setPricingPlanId(pricingPlanId) {
  return {
    type: SET_PRICING_PLAN_ID,
    payload: pricingPlanId
  };
};
export var UPDATE_CUSTOMER_RATE_SHEET_USAGE_RULES = 'UPDATE_CUSTOMER_RATE_SHEET_USAGE_RULES';
export var updateCustomerRateSheetUsageRules = function updateCustomerRateSheetUsageRules(modifiedUsageRule) {
  return {
    type: UPDATE_CUSTOMER_RATE_SHEET_USAGE_RULES,
    payload: modifiedUsageRule
  };
};
export var ADD_USAGE_RULE_ITEMS = 'ADD_USAGE_RULE_ITEMS';
export var addUsageRuleItems = function addUsageRuleItems(addedItems) {
  return {
    type: ADD_USAGE_RULE_ITEMS,
    payload: addedItems
  };
};
export var MODIFIED_USAGE_RULE_ITEMS = 'MODIFIED_USAGE_RULE_ITEMS';
export var setModifiedUsageRuleItems = function setModifiedUsageRuleItems(modifiedItems) {
  return {
    type: MODIFIED_USAGE_RULE_ITEMS,
    payload: modifiedItems
  };
};
export var SEARCH_PRICING_VECTORS = {
  BEGIN: 'SEARCH_PRICING_VECTORS_BEGIN',
  SUCCESS: 'SEARCH_PRICING_VECTORS_SUCCESS',
  FAILURE: 'SEARCH_PRICING_VECTORS_FAILURE'
};
var SEARCH_PRICING_VECTORS_EVENTS = [SEARCH_PRICING_VECTORS.BEGIN, SEARCH_PRICING_VECTORS.SUCCESS, SEARCH_PRICING_VECTORS.FAILURE];
export var searchPricingVectorsPromise = function searchPricingVectorsPromise(dispatch, data) {
  return ThunkHelper(dispatch, SEARCH_PRICING_VECTORS_EVENTS, {
    method: 'post',
    data: data,
    url: 'SubscriberManagement/SearchPricingVectors'
  });
};
export var searchPricingVectors = function searchPricingVectors() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch) {
    return searchPricingVectorsPromise(dispatch, data);
  };
};
export var SET_RATE_SHEET_DETAILS_TAB = 'SET_RATE_SHEET_DETAILS_TAB';
export var setRateSheetDetailsTab = function setRateSheetDetailsTab(tabValue) {
  return {
    type: SET_RATE_SHEET_DETAILS_TAB,
    payload: tabValue
  };
};
export var SET_UBRI_TO_USAGE_RULE_GROUP_MAP = 'SET_UBRI_TO_USAGE_RULE_GROUP_MAP';
export var setUbriToUsageRuleGroupMap = function setUbriToUsageRuleGroupMap(map) {
  return {
    type: SET_UBRI_TO_USAGE_RULE_GROUP_MAP,
    payload: map
  };
};
export var RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS = {
  BEGIN: 'RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS_BEGIN',
  SUCCESS: 'RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS_SUCCESS',
  FAILURE: 'RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS_FAILURE'
};
var RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS_EVENTS = [RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS.BEGIN, RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS.SUCCESS, RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS.FAILURE];
export var retrieveUsageRulesForUsageRuleGroupsPromise = function retrieveUsageRulesForUsageRuleGroupsPromise(dispatch, data) {
  return ThunkHelper(dispatch, RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS_EVENTS, {
    method: 'post',
    data: {
      UsageRuleGroupExternalReferences: data
    },
    url: 'SubscriberManagement/RetrieveUsageRulesForUsageRuleGroups'
  });
};
export var retrieveUsageRulesForUsageRuleGroups = function retrieveUsageRulesForUsageRuleGroups() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch) {
    return retrieveUsageRulesForUsageRuleGroupsPromise(dispatch, data);
  };
};